import { Component } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { GameState } from '../../../../shared/enums/gamestate.enum';
import { State } from '../../../../shared/interfaces/state.interface';
import { GameService } from '../../../../shared/services/game.service';
import { MessageService } from '../../../../shared/services/message.service';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class CardsComponent {
  fibonacciSequence: Array<string> = ["0", "1/2", "1", "2", "3", "5", "8", "13", "20", "40", "100", "?", "Koffie"];

  selectedCard: string;

  constructor(private gameService: GameService, private messageService: MessageService) {
    this.gameService.stateUpdateReceived$
      .pipe(takeUntil(this.gameService.onDestroy$))
      .subscribe((newState: State) => {
        if (newState.GameState == GameState.ShowVotes) {
          this.selectedCard = null;
          this.gameService.hasVoted = false;
        }
      }
    );
  }

  selectCard(selectedValue) {
    let newCard = this.selectedCard === selectedValue ? null : selectedValue;
    this.gameService.castVote(newCard)
      .then(() => {
        this.selectedCard = newCard;
      })
      .catch(() => {
        this.messageService.showWarning('U kunt nu niet stemmen')
        this.selectedCard = null;
      })
  }
}
